/**
 * Prefstest FAQ Accordion
 * ────────────────────
 * Manages accordion behavior: only one <details> open at a time within
 * a [data-prefstest-faq-group] container. Uses event delegation for
 * efficiency. No dependencies.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    // In design mode: allow all details to stay open for editing
    if (window.Shopify && window.Shopify.designMode) return;

    const summary = event.target.closest('[data-prefstest-faq-group] summary');
    if (!summary) return;

    const details = summary.closest('details');
    if (!details) return;

    const group = details.closest('[data-prefstest-faq-group]');
    if (!group) return;

    // If this item is about to open, close all siblings
    if (!details.open) {
      const items = group.querySelectorAll('details[open]');
      for (let i = 0; i < items.length; i++) {
        if (items[i] !== details) {
          items[i].removeAttribute('open');
        }
      }
    }
  });
})();
